/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'

export const isUnavailable = (t: Listable | Pin | Property) =>
  t.features?.includes(PropertyFeatures.IS_UNAVAILABLE)
